import styled from "styled-components/macro";
import { media } from "../../../../utils";

export const OnlyDesktopHeadline = styled.span(() => ({
  color: "#500778",
  display: "none",
  [media.lg()]: {
    display: "block",
  },
}));

export default null;
